import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import appConstants from "../../../../../appConstants";
import styles from "./styles";

const Benefits = ({ classes, kpiData, logData }) => {
  return (
    <Grid container item xs={12} className={classes.topMargin}>
      <Grid item xs={12} className={classes.kpiTopHeader}>
        Pickup assignments saved successfully
      </Grid>
      <Grid item xs={12} className={classes.kpiTopSubHeader}>
        Drivers are being notified.
      </Grid>
      <Grid container item xs={12}>
        <Grid item xs={2}></Grid>
        <Grid container item xs={8}>
          <Grid container item xs={12} className={classes.kpiBox}>
            <Grid item xs={4} className={classes.kpiValueBox}>
              <div className={classes.kpiBoxLabel}>
                Pickups Assigned:
                <span className={classes.kpiBoxHeader}>
                  {kpiData.pickupsAssigned}
                </span>
              </div>
            </Grid>
            <Grid item xs={4} className={classes.kpiValueBox}>
              <div className={classes.kpiBoxLabel}>
                Drivers Involved:
                <span className={classes.kpiBoxHeader}>
                  {kpiData.driversInvolved}
                </span>
              </div>
            </Grid>
            <Grid item xs={4} className={classes.kpiValueBox}>
              <div className={classes.kpiBoxLabel}>
                Optimization Runtime:
                <span className={classes.kpiBoxHeader}>
                  {kpiData.timeRequired}
                </span>
              </div>
            </Grid>
          </Grid>

          {logData?.length ? (
            <>
              <Grid item xs={12} className={classes.logHeader}>
                Optimization Status
              </Grid>
              <Grid
                container
                item
                xs={12}
                className={`${classes.logBox} customScroll`}
              >
                {logData.map((log, i) => (
                  <div key={`Benefits-${i}`} className={classes.showLog}>
                    <CheckCircleIcon className={classes.doneIcon} />
                    <span>
                      {` Pickup ${log.shipperName} - (${log.pickupNumber}) ${
                        log.event === appConstants.PICKUP_EVENTS.ASSIGN_PICKUP
                          ? " assigned to"
                          : " unassigned from"
                      } ${log.driverName} ${log.driverNumber} `}
                    </span>
                  </div>
                ))}
              </Grid>
            </>
          ) : null}
        </Grid>
        <Grid container item xs={2}></Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Benefits);
